import { MouseEvent, useEffect, useState } from 'react';
import { Input } from '../../../components/input/input';
import { pageKey } from '../../../helpers/path';
import { useLang } from '../../../hooks/use-lang';
import { useQueryParams } from '../../../hooks/use-query-params';
import { DropdownFilterPopup } from '../dropdown-filter-popup/dropdown-filter-popup';
import s from './dropdown-filter-range.module.css';

interface Props {
  name: string;
  isOpen: boolean;
  onOpen: (state: boolean) => void;
}

export const DropdownFilterRange = (props: Props) => {
  const { name, isOpen, onOpen } = props;

  const { addQueryParams, getQueryParams } = useQueryParams();
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const { t } = useLang();

  const params = getQueryParams();
  const range = params[name];

  useEffect(() => {
    if (!range) return;
    const asObj = JSON.parse(range);
    setFrom(asObj.from);
    setTo(asObj.to);
  }, [range]);

  const handleOk = (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent> | KeyboardEvent) => {
    const rangeParams =
      from || to ? JSON.stringify({ from: from || undefined, to: to || undefined }) : undefined;
    const resultParams = { [name]: rangeParams, [pageKey]: '1' };

    addQueryParams(resultParams);
    onOpen(false);
    e.stopPropagation();
  };

  const handleReset = () => {
    addQueryParams({ [name]: undefined, [pageKey]: '1', [`${name}-check`]: undefined });
    setFrom('');
    setTo('');
  };

  return (
    <DropdownFilterPopup
      isOpen={isOpen}
      onOpen={onOpen}
      className={s.feature}
      onReset={handleReset}
      onSubmit={handleOk}
      name={name}
    >
      <div className={s.range}>
        <Input
          value={from}
          onChange={(e) => setFrom(e.currentTarget.value)}
          placeholder={t('От')}
          type="number"
        />
        <Input
          value={to}
          onChange={(e) => setTo(e.currentTarget.value)}
          placeholder={t('До')}
          type="number"
        />
      </div>
    </DropdownFilterPopup>
  );
};
